import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function blockStyle({ $isBlock = false }: ButtonStyleProps) {
  if ($isBlock) {
    return css`
      display: block;
    `;
  }
}
